export default __webpack_public_path__ + "db8be8916c857a2b9d0740dc47707316.png";